import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../component/form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddUpdateTeamUsers = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  teamUserData = {},
  Style,
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  

  useEffect(() => {
    // console.log("teamUserData", teamUserData);
    // getRolls();
    getTeams();
    getUsers();

    // if(teamUserData?.userid){
    //   formik.setFieldValue("team_id", teamUserData?.team_id);
    //   formik.setFieldValue("user_id", teamUserData?.userid);
    //   // formik.setFieldValue("role_id", teamUserData?.role_id);

    // }
 
  }, []);

  const validationSchema = yup.object({
    team_id: yup.string().required("This Field is Required"),
    user_id: yup.string().required("This Field is Required"),
    // role_id: yup.string().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      team_id: "",
      user_id: "",
      // role_id: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        team_id: Number(values.team_id),
        user_id: Number(values.user_id),
        // role_id: Number(values.role_id),
      };

      console.log("values", values);

      try {
        const url = `teams/add-team-user`;
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        if (onSubmit) onSubmit(apiRes?.message || "Add Team successfully");

        formik.resetForm();
        onClose();
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [rolls, setRolls] = useState([]);

  const getTeams = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `teams/teams-list`,
      });
      setTeams(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };
  const getRolls = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/user-type-list`,
      });
      setRolls(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };
  const getUsers = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });
      setUsers(res?.agents);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const teamsOptions = teams?.map((tm) => ({
    value: tm?.id,
    label: tm?.team_name + ` (${tm?.ttype})`,
  }));
  const rollsOptions = rolls?.map((tm) => ({
    value: tm?.usertypeid,
    label: tm?.usertype,
  }));
  const usersOptions = users?.map((tm) => ({
    value: tm?.userid,
    label: tm?.name,
  }));

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* Teams */}
            <FeildWraper width="100%">
              <FormLabel required>Teams</FormLabel>

              <Select
                name="team_id"
                className="text-sm"
                classNamePrefix="react-select"
                options={teamsOptions}
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                value={teamsOptions?.find(
                  (option) => option.value == formik?.values?.team_id
                )}
                onChange={(selectedOption) => {
                  formik.setFieldValue("team_id", selectedOption?.value || "");
                }}
                filterOption={(option, inputValue) =>
                  option?.label
                    .toLowerCase()
                    .includes(inputValue?.toLowerCase())
                }
                placeholder="Search or select Teams..."
                isClearable
                menuPlacement="auto"
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.team_id && formik.errors.team_id && (
                <FeildError>{formik.errors.team_id}</FeildError>
              )}
            </FeildWraper>

            {/* User Type */}
            <FeildWraper  width="100%">
              <FormLabel required>Users</FormLabel>

              <Select
                name="user_id"
                className="text-sm"
                classNamePrefix="react-select"
                options={usersOptions}
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                value={usersOptions?.find(
                  (option) => option.value == formik?.values?.user_id
                )}
                onChange={(selectedOption) => {
                  formik.setFieldValue("user_id", selectedOption?.value || "");
                }}
                filterOption={(option, inputValue) =>
                  option?.label
                    .toLowerCase()
                    .includes(inputValue?.toLowerCase())
                }
                placeholder="Search or select Users..."
                isClearable
                menuPlacement="auto"
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.user_id && formik.errors.user_id && (
                <FeildError>{formik.errors.user_id}</FeildError>
              )}
            </FeildWraper>

            {/* Rolls*/}
            {/* <FeildWraper  width="100%">
              <FormLabel required>Role</FormLabel>

              <Select
                name="role_id"
                className="text-sm"
                classNamePrefix="react-select"
                options={rollsOptions}
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                value={rollsOptions?.find(
                  (option) => option.value == formik?.values?.role_id
                )}
                onChange={(selectedOption) => {
                  formik.setFieldValue("role_id", selectedOption?.value || "");
                }}
                filterOption={(option, inputValue) =>
                  option?.label
                    .toLowerCase()
                    .includes(inputValue?.toLowerCase())
                }
                placeholder="Search or select Role..."
                isClearable
                menuPlacement="auto"
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.role_id && formik.errors.role_id && (
                <FeildError>{formik.errors.role_id}</FeildError>
              )}
            </FeildWraper> */}
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {teamUserData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdateTeamUsers;
